import { z } from "zod";

import type { AWS } from "@serverless/typescript";

export const WebUiScopeList = [
  "debug",
  "view_new_dashboard",
  //  All Experiences
  "view_analytics",
  //  Shipping Experience
  "view_shipping_experiment",
  "create_shipping_experiment",
  "start_shipping_experiment",
  "edit_shipping_experiment",
  // Content Experience
  "view_content_experiment",
  "create_content_experiment",
  "start_content_experiment",
  "edit_content_experiment",
  //  Price Experience
  "view_price_experiment",
  "create_price_experiment",
  "start_price_experiment",
  "edit_price_experiment",
  // Offer Experience
  "view_volume_discount",
  "view_discount_experiment",
  "create_discount_experiment",
  "start_discount_experiment",
  "edit_discount_experiment",
  "personalizations",
  //  Other
  "edit_advanced_settings",
] as const;
export type WebUiScopeType = (typeof WebUiScopeList)[number];

export type LambdaFunction = NonNullable<AWS["functions"]>[string];

// @ts-ignore
export type AwsResource = NonNullable<AWS["resources"]["Resources"]>[string];

const baseConfigHistoryDso = z.object({
  action: z.enum(["add", "update", "delete"]),
  entity: z.string(),
  entityId: z.string(),
  entityName: z.string(),
  parentEntityId: z.string(),
  editedKey: z.string(),
  from: z.string(),
  to: z.string(),
});

export type ConfigHistoryChangeLogDto = z.infer<typeof baseConfigHistoryDso> & {
  edits: ConfigHistoryChangeLogDto[];
};

export const ConfigHistoryChangeLogDso: z.ZodType<ConfigHistoryChangeLogDto> =
  baseConfigHistoryDso.extend({
    edits: z.lazy(() => ConfigHistoryChangeLogDso.array()),
  });

export const ConfigEventDso = z.object({
  key: z.string(),
  ts: z.number(),
});

export type ConfigEventDto = z.infer<typeof ConfigEventDso>;
